export const REFERRAL_PAYOUT_AMOUNT_USD = 100;
